import {
  Card,
  CardBody,
  CardFooter,
} from "@material-tailwind/react";
import React from "react";
import { Input, Select, Option } from "@material-tailwind/react";
import { useState } from "react";
import abi from "../../utils/AuctionRegistry.json";

import { ethers} from "ethers";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";

export function PatientServiceCreation() {
  const [errorMessage, setErrorMessage] = useState();

  const [bidParameter, setBidParameters] = useState({
    minBudget: "",
    maxBudget:"",
    deadline: "",
    service: "",
    zipcode: "",
  });
  
  const [zipcodeValidationColor, setZipcodeValidationColor] = useState("");

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(!open);

  const contractAddress = process.env.REACT_APP_REGISTRY_CONTRACT_ADDRESS;
  const contractABI = abi;

  const validateZipCode = async (zipcode) => {
    try {
      const response = await fetch(`https://api.zippopotam.us/us/${zipcode}`);
      if (response.status === 200) {
        setZipcodeValidationColor("green"); // valid zipcode
      } else {
        setZipcodeValidationColor("red"); // invalid zipcode
      }
    } catch (error) {
      setZipcodeValidationColor("red"); // error or invalid zipcode
    }
  };

  const placeBid = async (e) => {
    e.preventDefault();
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const deployedContract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );
      // console.log(deployedContract);
      const txResponse = await deployedContract.createAuction(
        bidParameter.service,
        Math.round(bidParameter.deadline * 3600),
        bidParameter.minBudget,
        bidParameter.maxBudget,
        bidParameter.zipcode
      );
      // console.log(txResponse)
      const txReceipt = await txResponse.wait();
      const event = txReceipt.events?.find((e) => e.event === "AuctionCreated");
      // Extract the auctionContract address
      // console.log(event);
      // if (event && event.args) {
      //   console.log("Auction Contract Address:", event.args.auctionContract);
      // }

      // const result = await deployedContract.bid(bidParameter.price, bidParameter.provider, bidParameter.service, { value: bidParameter.price });
      // console.log(result)
    } catch (error) {
      //const revertedMessage = error.message.split('reverted: ')[1].split("'")[0].split("\"")[0];
      const revertedMessage = error.message;
      setErrorMessage(revertedMessage);
      handleOpen();
    }
  };
  // const handleChange = async (e) => {
  //   e.preventDefault();
  //   const { name, value } = e.target;

  //   setBidParameters({
  //     ...bidParameter,
  //     [e.target.name]: e.target.value,
  //   });
  //   if (name === "zipcode" && value.length === 5) {
  //     await validateZipCode(value);
  //   }
  // };

  const handleChange = (e) => {
    if (e && typeof e === 'object' && e.target) {
      const { name, value } = e.target;
      setBidParameters(prevState => ({
          ...prevState,
          [name]: value
      }));
      if (name === 'zipcode') {
          validateZipCode(value);
      }
  } else {
      // This is for Material Tailwind Select component
      // Assuming 'service' is the name for Select component
      setBidParameters(prevState => ({
          ...prevState,
          service: e // e is the value directly in this case
      }));
  }
}

const services = [
  { label: 'Service 1', value: 'service1' },
  { label: 'Service 2', value: 'service2' },
  { label: 'Service 3', value: 'service3' },
];

  return (
    <div className="flex justify-center items-center h-full w-full">
      <Card className="m-5 w-full max-w-screen-md">
        <CardBody>
          <div className="mb-5">
          <Select
      label="Choose your desired service*"
      color="blue"
      name="service"
      value={bidParameter.service}
      onChange={handleChange}
    >
      {services.map(service => (
        <Option key={service.value} value={service.value}>
          {service.label}
        </Option>
      ))}
    </Select>
            {/* <Input
              color="blue"
              label="Service*"
              name="service"
              value={bidParameter.service}
              onChange={handleChange}
              autocomplete="off"
            /> */}
          </div>
          <div className="w-90 mb-5">
            <Input
              color="blue"
              label="Minimum Budget*"
              name="minBudget"
              value={bidParameter.minBudget}
              onChange={handleChange}
              autocomplete="off"
            />
          </div>
          <div className="w-90 mb-5">
            <Input
              color="blue"
              label="Maximum Budget*"
              name="maxBudget"
              value={bidParameter.maxBudget}
              onChange={handleChange}
              autocomplete="off"
            />
          </div>
          <div className="w-90 mb-5">
            <Input
              color="blue"
              label="Deadline* (in hours)"
              name="deadline"
              value={bidParameter.deadline}
              onChange={handleChange}
              autocomplete="off"
            />
          </div>
          <div className="w-90">
            <Input
              color="blue"
              label="Zipcode*"
              name="zipcode"
              value={bidParameter.zipcode}
              onChange={handleChange}
              autocomplete="off"
              style={{ borderColor: zipcodeValidationColor }}
            />
          </div>
        </CardBody>
        <CardFooter className="pt-0">
          <Button color="teal" onClick={placeBid} type="button">
            Create
          </Button>
        </CardFooter>

        <Dialog
          open={open}
          handler={handleOpen}
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogHeader>Oops, it's on us!</DialogHeader>
          <DialogBody divider>{errorMessage}</DialogBody>
          <DialogFooter>
            {/* <Button
            variant="text"
            color="red"
            onClick={handleOpen}
            className="mr-1"
          >
            <span>Cancel</span>
          </Button> */}
            <Button variant="gradient" color="green" onClick={handleOpen}>
              <span>Okay, Thank you!</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </Card>
    </div>
  );
}
